module.exports = __webpack_public_path__ + "static/media/OHrdlička-96-2.5509b403.jpg";